<template>
  <section class="home-support  home-container">
			<h3 class="home-title">核心功能能及服务</h3>
			<div class="home-support__container">

				<div class="homeSupport-item" v-for="(item,index) in functionAndServices" :key="index" >
					<span class="homeSupport-item__icon">
						<img :src="item.src" :alt="item.label">
					</span>
					<div class="homeSupport-item__right">
						<h4 class="homeSupport-item__right_title">{{ item.label }}</h4>
						<p class="homeSupport-item__right_content">{{ item.content }}</p>
					</div>
				</div>
			</div>

		</section>
</template>

<script>
export default {
    name: 'home-support',
    data(){
        return {
          functionAndServices: [
            {
              id: 0,
              name: 'sheduling',
              label: '算力调度',
              content: '高效地分配、管理、监控和弹性调度GPU等异构资源算力，提供分布式并行训练能力。',
              src: require('../../assets/images/sheduling.png')
            },
            {
              id: 1,
              name: 'environment',
              label: '训练环境',
              content: '各种AI框架: TensorFlow、Keras、PyTorch等，灵活的MLab交互式工具和训练环境。',
              src: require('../../assets/images/environment.png')
            },
            {
              id: 2,
              name: 'task',
              label: '训练任务',
              content: '高效作业管理，AI训练任务提交和管理，高效算法模型训练能力。',
              src: require('../../assets/images/task.png')
            },
            {
              id: 3,
              name: 'datamanage',
              label: '数据管理',
              content: '数据标注/管理: 模型溯源、快照/版本管理、共享等功能，模型一键发布至平台共享和统一管理。',
              src: require('../../assets/images/datamanage.png')
            },
            {
              id: 4,
              name: 'modelcenter',
              label: '模型中心',
              content: '各类算法和模型服务通过PaaS能力输出并提供给开发者和其它智能应用使用。',
              src: require('../../assets/images/modelcenter.png')
            },
          ],
        }
    },
    props: {

    }
}
</script>

<style scoped>

.home-support {
	padding-bottom: 12vw;
	background: #f1f7ff;
}
.home-support__container {
	font-size: 0;
}
.homeSupport-item {
	position: relative;
	display: flex;
	min-height: 27.333333333333332vw;
	padding: 3.466666666666667vw 4.933333333333334vw 2.933333333333333vw 3.3333333333333335vw;
	overflow: hidden;
	font-size: 1.6vw;
	text-align: left;
	vertical-align: top;
	background: #E7F1FF;
	box-sizing: border-box;
	box-shadow:0vw 0.5333333333333333vw 1.0666666666666667vw 0vw rgba(37,53,73,0.06);
}
.homeSupport-item+.homeSupport-item {
	margin-top: 3.066666666666667vw;
}
.homeSupport-item[data-type="wait"]:after {
	position: absolute;
	top: 3.466666666666667vw;
	right: -6.033978666666667vw;
	width: 16.970562666666666vw;
	line-height: 6.033978666666667vw;
	color: #fff;
	text-align: center;
	background: #00D5DF;
	content: '敬请期待';
	transform: rotate(45deg);
	transform-origin: 10.936584vw 0;
}
.homeSupport-item__icon {
	margin: -.25ex 3.7333333333333334vw 0 0;
}
.homeSupport-item__icon>:first-child {
	display: inline-block;
	width: 8vw;
	height: 8vw;
}
.homeSupport-item__right {
	font-size: 2.6666666666666665vw;
	flex: 1;
}
.homeSupport-item__right_title {
	font-size: 1.33333em;
	color: #253549;
}
.homeSupport-item__right_content {
	margin-top: 1em;
	line-height: 2;
	color: #575A66;
}


</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/ai-function-and-serivces.vue